export const colors: { [key: string]: { bg: string; text: string } } = {
  purple: {
    bg: '#e5e1ea',
    text: '#320564',
  },
  green: {
    bg: '#f3fbf3',
    text: '#285c34',
  },
  yellow: {
    bg: '#fdf7e5',
    text: '#724204',
  },
  blue: {
    bg: '#e0e4fa',
    text: '#151e51',
  },
  red: {
    bg: '#fef0f3',
    text: '#620410',
  },
};
